/**
 * 通常バナーと Social Bar の見た目の違いの絵（広告のカード・2026-10-19 design/visual-guides・founder「バナーと Social Bar の見た目の違いを絵で」）。
 * 2 台のスマホの絵: 左 = 下に固定の帯（320×50）、右 = ゲームの画面の上に重なるお知らせのような広告 + タブの文字が「(1) New Message!」に変わる。
 * 事実は displayAds.kind.* / displayAds.sb.*（examples/adsterra-banner-demo/README.md）と同じ。Social Bar は形が毎回変わる（全画面のこともある）ので、
 *   絵は 1 つの例 = 札の文は「画面の上に重なる」だけにして、形の種類は下の畳み（What Social Bar is like）に任せる。
 * 本物の広告・ロゴは描かない（灰色の箱と「Ad」の字だけ）。色はダッシュボードの変数 = 暗い表示に付く。サイトの広告の案内（apps/site/src/screens.mjs ads-*）と同じ形
 */
import { useT } from '../i18n';

/** bannerOnly: KUMODeck 自身の広告だけの間（displayAds.ts kumoAdsOnly）は Social Bar の絵を出さない（そのゲームには出ない・2026-10-27 console/earn-ads-card） */
export function DisplayAdsPictures({ bannerOnly = false }: { bannerOnly?: boolean }) {
  const { t } = useT();
  return (
    <div className="ads-pics" role="group" aria-label={t('displayAds.pic.label')}>
      <figure className="ads-pic">
        <span className="ads-phone" role="img" aria-label={t('displayAds.pic.alt.banner')}>
          <span className="ads-tab">your-app</span>
          <span className="ads-screen">
            <span className="ads-game" />
            <span className="ads-banner">Ad · 320×50</span>
          </span>
        </span>
        <figcaption>{t('displayAds.pic.banner')}</figcaption>
      </figure>
      {!bannerOnly && (
        <figure className="ads-pic">
          <span className="ads-phone" role="img" aria-label={t('displayAds.pic.alt.socialBar')}>
            <span className="ads-tab is-changed">(1) New Message!</span>
            <span className="ads-screen">
              <span className="ads-game" />
              <span className="ads-pop">
                <i />
                <span>
                  <b>Ad</b>
                  <span className="ads-pop-line" />
                </span>
                <em>×</em>
              </span>
            </span>
          </span>
          <figcaption>{t('displayAds.pic.socialBar')}</figcaption>
        </figure>
      )}
    </div>
  );
}
